import React, { useContext } from "react";
import style from "./index.module.scss";
import { message, Modal, Tooltip } from "antd";
import moment from "moment";
import ListStatics from "../ListStatics";
import { useHistory } from "react-router-dom";
import { CourseContext } from "pages/CourseDetail/Store";
import qs from "qs";
import ListStatus from "../ListStatus";
import ListLinks from "../ListLinks";
import ListDropDown from "../ListDropDown";
import {
    PublishStatus,
    activityListItem,
    deleteGroupActivity,
    GroupType
} from "../../../../../service/group";
import { errorMessage, isTrue } from "service/service";
import AddGroupActivityModal from "../AddGroupActivityModal";
import useModalHandler from "utils/useModalHandler";
import { useSetAtom } from "jotai";
import { TouchedAtom } from "../../store";
import { ResultMessage } from "components/ResultMessage";
import SubmitError from "components/SubmitError";
import classNames from "classnames";

interface ListItemProp {
    item: activityListItem; //活动项
    updateList?: () => void;
}

export default function ListItem({ item, updateList }: ListItemProp) {
    const history = useHistory();
    const editModal = useModalHandler();
    const { basename } = useContext(CourseContext);
    const updateTouched = useSetAtom(TouchedAtom);

    const { activityBaseInfo, dcGroupActivityStatics } = item;

    //删除
    function onDelete() {
        Modal.confirm({
            title: "确认删除小组活动吗？",
            content:
                "删除小组活动将同时删除小组活动任务及学生作答结果，请谨慎操作。",
            onOk: async () => {
                try {
                    await deleteGroupActivity(activityBaseInfo.id);
                    await updateList?.();
                    message.success("删除成功");
                } catch (e) {
                    ResultMessage.error(
                        <SubmitError
                            title="删除失败"
                            content={errorMessage(e)}
                        />,
                        { width: 300 }
                    );
                }
            }
        });
    }

    //保存
    const onOk = () => {
        updateList && updateList();
        updateTouched(false);
    };

    function gotoDetail(id: number, params?: StringMap) {
        const query = params ? `?${qs.stringify(params)}` : "";
        history.push(`${basename}/group/detail/${id}${query}`);
    }

    return (
        <div className={style.root}>
            <div
                className={classNames(
                    style.icon,
                    activityBaseInfo.groupType === GroupType.base && style.base
                )}>
                {!isTrue(activityBaseInfo.groupType) ? "固定小组" : "随机小组"}
            </div>
            <h1 className={style.title}>
                <Tooltip title={activityBaseInfo.activityName}>
                    {activityBaseInfo.activityName}&nbsp;&nbsp;
                </Tooltip>
                <ListStatus
                    state={activityBaseInfo.publishStatus}
                    hasTask={activityBaseInfo.hasTask}
                />
            </h1>

            <div className={style.info}>
                {activityBaseInfo.deadlineStr &&
                    moment().isAfter(moment(activityBaseInfo.deadlineStr)) && (
                        <span style={{ color: "red" }}>
                            【已结束】&nbsp;&nbsp;
                        </span>
                    )}
                <span>
                    截止时间&nbsp;&nbsp;
                    {activityBaseInfo.deadlineStr
                        ? moment(activityBaseInfo.deadlineStr).format(
                              "YYYY-MM-DD HH:mm:ss"
                          )
                        : "--"}
                </span>
            </div>

            <div className={style.tools}>
                <div className={style.opacity}>
                    <ListLinks
                        item={item}
                        status={activityBaseInfo.publishStatus}
                        onEdit={editModal.open}
                        onOk={onOk}
                        onDelete={onDelete}
                        gotoReview={gotoDetail}
                    />
                </div>

                {activityBaseInfo.publishStatus === PublishStatus.Yes && (
                    <div className={style.show}>
                        <ListStatics
                            id={activityBaseInfo.id}
                            allCount={dcGroupActivityStatics.totalGroupCount}
                            judgeCount={
                                dcGroupActivityStatics.hasCorrectedCount
                            }
                            noJudgeCount={
                                dcGroupActivityStatics.notCorrectedCount
                            }
                            noJoinIn={dcGroupActivityStatics.notPartInCount}
                            gotoDetail={gotoDetail}
                        />
                    </div>
                )}

                <div className={style.opacity}>
                    {activityBaseInfo.publishStatus === PublishStatus.Yes && (
                        <ListDropDown
                            item={activityBaseInfo}
                            updateList={updateList}
                            onDelete={onDelete}
                            onEdit={editModal.open}
                        />
                    )}
                </div>
            </div>

            {editModal.render(
                <AddGroupActivityModal
                    initValue={item.activityBaseInfo}
                    visible={editModal.visible}
                    onCancel={editModal.close}
                    onOk={onOk}
                />
            )}
        </div>
    );
}
